// The use-cases family's English words (ADR-034 point 1): only this family edits them. What every
// use-case page shares sits here; a page's own words sit in its own two files.
export const USE_CASES_WORDS_EN = {
  footerTitle: "Use cases",
  home: "Home",
  eyebrow: "Use case",
  stepsTitle: "The job, in three steps",
  sampleTitle: "A sample result",
  sampleCaption: "Made-up profiles and masked contacts: this is a sample, not real data.",
  columns: { name: "Name and username", type: "Type", email: "Email", phone: "Phone" },
  types: { business: "Business", personal: "Personal" },
  noneShown: "none shown",
  getTitle: "What you get",
  limitTitle: "The limit",
  questionsTitle: "Questions, answered",
  relatedTitle: "Keep reading",
};
